// @flow
import React, { Component } from 'react';
import Snackbar from 'material-ui/Snackbar';

const COOKIE_DISCLAIMER_KEY = 'EU_COOKIE_DISCLAIMER_DISMISSED';

const styles = {
  body: {
    lineHeight: '20px',
    paddingTop: 16,
    height: 60,
  },
};

export default class CookieDisclaimer extends Component {
  state = {
    open: !localStorage[COOKIE_DISCLAIMER_KEY],
  };

  handleClose() {
    localStorage.setItem(COOKIE_DISCLAIMER_KEY, true);
    this.setState({ open: false });
  }

  render() {
    const message = (
      <span>
        A legter.hu oldal cookie-kat (sütiket) használ a felhasználói élmény
        javítása érdekében. Az oldal további használatával ehhez hozzájárulsz.
      </span>
    );

    return (
      <Snackbar
        open={this.state.open}
        autoHideDuration={5000}
        message={message}
        bodyStyle={styles.body}
        onRequestClose={() => this.handleClose()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/CookieDisclaimer/CookieDisclaimer.js